<div class="container-fluid">
    <div class="row mt-10">
        <div class="col-md-6 title">Unit</div>
        <div class="col-md-6">{{Instruction.units}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued From</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDate(Instruction.issuedFrom)}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued To</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDate(Instruction.issuedTo??"")}}</div>
    </div>

    <div class="row mt-10">
        <div class="col-md-6 title">Date Comments</div>
        <div class="col-md-6">{{Instruction.dateComment}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Status</div>
        <div class="col-md-6">{{Instruction.status}}
            @if(Instruction.isArchived){
            - Archived
            }
        </div>
    </div>
    @if(Instruction.status == 'New' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Acknowledged')">
                Acknowledge
            </nj-button>
        </div>
    </div>}

    @if(Instruction.status == 'Acknowledged' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Completed')">
                Complete
            </nj-button>
        </div>
    </div>}
    <!-- Archive / UnArchive -->
    @if(UserService.getUser()?.CanArchive){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="ChangeStatus(Instruction.isArchived ? 'UnArchive' : 'Archive')">
                {{ Instruction.isArchived ? 'Unarchive' : 'Archive' }}
            </nj-button>
        </div>
    </div>}

    @if(Instruction.isAppliedInPPA == false){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ApplyToEDT()">
                Apply to EDT
            </nj-button>
        </div>
    </div>
    }
    @else {
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6" [style]= "'font-weight: bold; color: green;'">
            Applied to EDT
        </div>
    </div>
    }

    @if (Instruction.units == "MOWWO-4") {
    <div class="row mt-10">
        <div class="col-md-6 title">Monthly Fixed Elements</div>
        <div class="col-md-6">{{Instruction.fixed}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">REGO Price</div>
        <div class="col-md-6">{{Instruction.regoPrice}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Percentage</div>
        <div class="col-md-6">{{Instruction.percentage}}</div>
    </div>
    }
    @else {
    <div class="row mt-10">
        <div class="col-md-6 title">Monthly Fixed Elements</div>
        <div class="col-md-6">{{Instruction.fixed}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Strike Price</div>
        <div class="col-md-6">{{Instruction.strikePrice}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Negative Price Trigger</div>
        <div class="col-md-6">{{Instruction.negativePriceTrigger}}</div>
    </div>

    <div class="row mt-10">
        <div class="col-md-6 title">Amazon 1 PPA</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Commisioning Output</div>
        </div>
        <div class="col-md-6">{{Instruction.amazon_commissioning}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Contracted Electrical Output</div>
        </div>
        <div class="col-md-6">{{Instruction.amazon_contracted}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Payment Element</div>
        </div>
        <div class="col-md-6">{{Instruction.amazon_commercial}}</div>
    </div>


    <div class="row mt-10">
        <div class="col-md-6 title">Google PPA</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Commissioning Output</div>
        </div>
        <div class="col-md-6">{{Instruction.google_commissioning}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Contracted Electrical Output</div>
        </div>
        <div class="col-md-6">{{Instruction.google_contracted}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Minimum Payment Element</div>
        </div>
        <div class="col-md-6">{{Instruction.google_commercial_min}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Maximum Payment Element</div>
        </div>
        <div class="col-md-6">{{Instruction.google_commercial_max}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Engie Nose 1 PPA</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Commissioning Output</div>
        </div>
        <div class="col-md-6">{{Instruction.engie_commissioning}}</div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="col-md-1"></div>
            <div class="col-md-11">Contracted Electrical Output</div>
        </div>
        <div class="col-md-6">{{Instruction.engie_contracted}}</div>
    </div>
    }
</div>